import React from "react";
import PropTypes from "prop-types";
import { InputAdornment } from "@material-ui/core";
import EditTextField from "./EditTextField";

function EditPercentageTextField(props) {
  return (
    <EditTextField
      {...props}
      type={"number"}
      value={props.percentage ? props.percentage : 0}
      onBlur={(value, setBeginValue, setValue) => {
        if (value === "") {
          props.onBlur(0, setBeginValue, setValue);
        } else {
          props.onBlur(parseFloat(value), setBeginValue, setValue);
        }
      }}
      endAdornment={<InputAdornment position="end">%</InputAdornment>}
    />
  );
}

EditPercentageTextField.propTypes = {
  authorizationField: PropTypes.string,
  percentage: PropTypes.number,
  onBlur: PropTypes.func.isRequired,
};

export default EditPercentageTextField;
